import { EipConfig } from '@schir-int-client/api-root';
import { EipUser } from './eip.model';
import { XmlUtil } from './xml/xml.util';
import { VerfahrenResource } from '@schir-int-client/verfahren-shared';

export class EipMessages {
	private static XMLNS_APPLICATION = 'http://eip.justiz.de/application/integration/v5';
	private static XMLNS_SECURITY = 'http://eip.justiz.de/security/integration/v5';
	private static XMLNS_FRAME = 'http://eip.justiz.de/frame/integration/v5';
	private static XMLNS_LAWSUIT = 'http://eip.justiz.de/lawsuitcontext/integration/v5';

	static registerApplicationRequest(applicationId: string, applicationInstanceId: string): string {
		return XmlUtil.obj2Xml({
			RegisterApplicationRequest: {
				$xmlns: this.XMLNS_APPLICATION,
				ApplicationId: applicationId,
				ApplicationInstanceId: applicationInstanceId,
			},
		});
	}

	static applicationReadyRequest(applicationId: string, applicationInstanceId: string): string {
		return XmlUtil.obj2Xml({
			ApplicationReadyRequest: {
				$xmlns: this.XMLNS_APPLICATION,
				ApplicationId: applicationId,
				ApplicationInstanceId: applicationInstanceId,
			},
		});
	}

	static loginResponse(user: EipUser, config: EipConfig): string {
		return XmlUtil.obj2Xml({
			LoginResponse: {
				$xmlns: this.XMLNS_SECURITY,
				Result: {
					Court: {
						Identifier: config.courtId,
						Location: config.courtLocation,
						ShortDescription: config.courtDescription,
						Type: config.courtType,
						TypeId: config.courtTypeId,
					},
					Division: {
						Identifier: 'schiffsregister',
						Name: 'schiffsregister',
						ShortDescription: 'schiffsregister',
					},
					User: {
						Firstname: user.firstName,
						JobDescription: user.jobDescription,
						Lastname: user.lastName,
						LoginId: user.loginId,
						Title: user.title,
					},
				},
			},
		});
	}

	static getCourtForOrganizationEntityResponse(config: EipConfig): string {
		return XmlUtil.obj2Xml({
			GetCourtForOrganizationEntityResponse: {
				$xmlns: this.XMLNS_SECURITY,
				Result: {
					Court: {
						Identifier: config.courtId,
						Location: config.courtLocation,
						ShortDescription: config.courtDescription,
						Type: config.courtType,
						TypeId: config.courtTypeId,
					},
				},
			},
		});
	}

	static addNewPartRequest(windowHandle: string): string {
		return XmlUtil.obj2Xml({
			AddNewPartRequest: {
				$xmlns: this.XMLNS_FRAME,
				PartTypeIdentifier: 'de.justiz.eip.schiffsregister.ui.part.schiffsregisterMainPart',
				ViewIdentifier: 'de.justiz.eip.schiffsregister.ui.view.centralmask',
				WindowHandle: windowHandle,
			},
		});
	}

	static showViewResponse(): string {
		return XmlUtil.obj2Xml({
			ShowViewResponse: {
				$xmlns: this.XMLNS_APPLICATION,
				Result: {},
			},
		});
	}

	static showViewErrorResponse(msg: string): string {
		return XmlUtil.obj2Xml({
			ShowViewResponse: {
				$xmlns: this.XMLNS_APPLICATION,
				ErrorInformation: { Message: msg },
			},
		});
	}

	static activateLawsuitContextRequest(aktenzeichen: string, config: EipConfig): string {
		return XmlUtil.obj2Xml({
			ActivateLawsuitContextRequest: {
				$xmlns: this.XMLNS_LAWSUIT,
				LawsuitId: config.eaktePrefix + '_' + config.courtId + '_' + aktenzeichen,
			},
		});
	}

	static closePartRequest(partInstanceIdentifier: string): string {
		return XmlUtil.obj2Xml({
			ClosePartRequest: {
				$xmlns: this.XMLNS_FRAME,
				PartInstanceIdentifier: partInstanceIdentifier,
			},
		});
	}

	static getLawsuitResponse(verfahren: VerfahrenResource, config: EipConfig) {
		const response = {
			GetLawsuitResponse: {
				Result: {
					Lawsuit: {
						Id: config.eaktePrefix + '_' + config.courtId + '_' + verfahren.aktenzeichen,
						Name: verfahren.aktenzeichen,
						OrganizationalEntity: {
							'security:Identifier': 'OE_1',
							'security:Name': 'OE',
							'security:Number': 1,
						},
					},
				},
			},
		};

		response['GetLawsuitResponse']['$xmlns'] = this.XMLNS_LAWSUIT;
		response['GetLawsuitResponse']['$xmlns:security'] = this.XMLNS_SECURITY;

		return XmlUtil.obj2Xml(response);
	}

	// @Deprecated: wahrscheinlich zu streichen, da createDigitalFile aus dem Backend gerufen wird.
	static createDigitalFileRequest(user: EipUser, config: EipConfig): string {
		const request = {
			CreateDigitalFileRequest: {
				'base:ExecutionContext': {
					'base:UserId': user.loginId,
					'base:OrganizationalEntityId': config.organizationalEntityId,
					'base:CourtId': config.courtId,
					'base:CourtLocation': config.courtLocation,
					'base:CourtTypeId': config.courtTypeId,
					'base:DivisionShortDescription': 'schiffsregister',
					'base:ApplicationId': 'schiffsregisterApp',
				},
				'DigitalFileId': config.eaktePrefix + '_' + config.courtId + '_file_001',
				'DigitalFileName': 'Test Datei',
				'OwnerOrganizationalEntityId': config.organizationalEntityId,
			},
		};

		request['CreateDigitalFileRequest']['$xmlns'] = 'http://eip.justiz.de/digitalfile/integration/v5';
		request['CreateDigitalFileRequest']['$xmlns:base'] = 'http://eip.justiz.de/base/integration/v5';

		return XmlUtil.obj2Xml(request);
	}
}
